import { LeadCurd } from "./leadCrud";

export default function PoolLeads() {
  return <LeadCurd name="公共池" type="pool" router="pool" />;
}
